import React from 'react';
import classnames from 'classnames';
import styles from './menu-item.scss';

import { dispatchNewEvent } from '../../utils/analytics/dispatchNewEvent';

type BreadcrumbItem =
  | string
  | number
  | {
      title?: string | number;
    }
  | null
  | undefined;

interface MenuItemProps {
  children?: React.ReactNode;
  href?: string;
  hasChildren?: boolean;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  shopAll?: boolean;
  className?: string;
  breadcrumb?: BreadcrumbItem[];
}

export const MenuItem = ({
  children,
  href,
  hasChildren,
  onClick,
  shopAll,
  className,
  breadcrumb,
}: MenuItemProps) => {
  const classes = classnames(
    styles.link,
    hasChildren && styles['menu-link--with-children'],
    shopAll && styles.shopAll
  );

  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (!hasChildren && breadcrumb) {
      const navPath = breadcrumb
        .filter(Boolean)
        .map(crumb =>
          typeof crumb === 'object' && crumb !== null
            ? crumb.title || crumb
            : crumb
        )
        .join('|');
      dispatchNewEvent('dataStateChange', {
        action: 'jl.navTracking',
        type: 'sf',
        navigation: `${navPath}|${children}`,
      });
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <li className={classnames(styles.item, className)}>
      <a className={classes} href={href} onClick={clickHandler}>
        {children}
      </a>
    </li>
  );
};
